import i18n from '../libs/i18n/i18n';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const IDPID = process.env.REACT_APP_IDPID;

const encodeBase64Utf8 = (value) => {
    const bytes = new TextEncoder().encode(value);
    let binary = '';
    bytes.forEach((byte) => {
        binary += String.fromCharCode(byte);
    });
    return window.btoa(binary);
};

const buildAgreementHtml = () => {
    const title = i18n.t('documentAgreement.title');
    const description = i18n.t('documentAgreement.description');
    return `<h1>${title}</h1><p>${description}</p>`;
};

export const signDocument = async (token,  pdfFile, requestJson) => {
    const url = `${BASE_URL}/signature/pdf?idpid=${IDPID}`;
    const fileName = sessionStorage.getItem('fileName');
    const completeSignRequest = {
        ...requestJson,
        agreement_html: encodeBase64Utf8(buildAgreementHtml())
    };
    const formData = new FormData();
    formData.append('content', pdfFile, fileName);
    formData.append(
        'request',
        new Blob([JSON.stringify(completeSignRequest)], { type: 'application/json' }),
        'request.json'
    );

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`
        },
        body: formData
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error al firmar documento: ${errorText}`);
    }
    const data = await response.json();

    let docId = '';
    if (Array.isArray(data.documents) && data.documents.length > 0) {
        docId = data.documents[0].id;
         if (docId.startsWith('"')) {
           docId = docId.substring(1, docId.length - 1);
         }
    }
    sessionStorage.setItem('docId', docId);
    sessionStorage.setItem('viewerEntry', 'fromSign');
    const pendingTasks = data?.tasks?.pending;
    if (Array.isArray(pendingTasks) && pendingTasks.length > 0 && pendingTasks[0].url) {
        window.location.href = pendingTasks[0].url;
    } else {
        throw new Error("No se encontró la URL de redirección en la respuesta.");
    }
};

export const getFullName = (data) => {
    return [data.primer_nombre, data.segundo_nombre, data.primer_apellido, data.segundo_apellido]
        .filter(Boolean) // Filtra valores nulos, undefined o vacíos
        .join(' '); // Une los elementos con un solo espacio
};